<!-- 答题 -->
<template>
  <div class="answer">
    <div class="header">
      <img @click="pushHome" alt src="@/assets/img/h5/left.png" />
      <div class="title" v-if="ExaminationInfo.examinationName">{{ExaminationInfo.examinationName}}</div>
    </div>
    <div class="my_Body">
      <div class="question_box">
        <div class="question_header">
          <div class="header_desc" v-if="question_type == 1">单选题</div>
          <div class="header_desc" v-if="question_type == 2">多选题</div>
          <div class="header_desc" v-if="question_type == 3">判断题</div>
          <div class="header_desc" v-if="question_type == 4">简答题</div>
          <div @click="istrue = true" class="header_count">
            <img src="@/assets/img/h5/newQuestiondown@2x.png" />
            <div>{{page_index}}/{{count}}</div>
          </div>
        </div>
        <div class="question_body" v-if="data_li">
          <RadioOption
            :bankdata="data_li"
            :typetext="'单选题'"
            v-if="question_type == 1"
            v-on:getchildval="getchildval"
          ></RadioOption>
          <CheckOption
            :bankdata="data_li"
            :typetext="'多选题'"
            v-if="question_type == 2"
            v-on:getchildval="getchildval"
          ></CheckOption>
          <RadioOption
            :bankdata="data_li"
            :typetext="'判断题'"
            v-if="question_type == 3"
            v-on:getchildval="getchildval"
          ></RadioOption>
          <!-- <TextOption
            :bankdata="data_li"
            :typetext="'简答题'"
            v-if="question_type == 4"
            v-on:getchildval="getchildval"
          ></TextOption>-->
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="time" v-if="useTimeSend > 300">
        <!-- <img alt src="@/assets/img/h5/collectes@2x.png" /> -->
        考试剩时: {{getDuration(useTimeSend)}}
      </div>
      <div class="timeOut" v-if="useTimeSend < 300">
        <!-- <img alt src="@/assets/img/h5/collectes@2x.png" /> -->
        考试最后剩时: {{getDuration(useTimeSend)}}
      </div>
      <div class="page">
        <el-pagination
          :current-page.sync="page_index"
          :disabled="loading"
          :page-size="1"
          :total="count"
          @current-change="handleSizeChange"
          layout="prev,next"
          next-text="下一页"
          prev-text="上一页"
        ></el-pagination>
        <div @click="submit_sub" class="submit" v-if="dataAll.length == page_index">提交</div>
      </div>
    </div>

    <AnswerSheet
      :activeindex="page_index"
      :bankdata="dataAll"
      :istrues="istrue"
      :numcount="numCount"
      v-if="dataAll "
      v-on:getstatus="getstatus"
      v-on:getvalue="getvalue"
    ></AnswerSheet>
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="submit_status"
      width="80%"
    >
      <div class="dialog_body">
        <div class="headers">
          <div>不要放弃，继续加油！</div>
        </div>
        <div class="img">
          <img alt src="@/assets/img/h5/newQuestioncomeon@2x.png" v-if="isBlack" />
          <img alt src="@/assets/img/h5/newQuestionfinish@2x.png" v-if="!isBlack" />
        </div>
      </div>
      <span class="submit-footer" slot="footer">
        <div @click="save" class="black">保存进度</div>
        <div @click="submit_status = false" class="submit">继续答题</div>
        <!-- <div @click="againStaring" class="submit">重新答题</div> -->
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="go_status"
      width="80%"
    >
      <div class="dialog_body">
        <div class="headers">
          <div v-if="isBlack">全部答完，确定提交？</div>
          <div v-if="!isBlack">
            <p>还有题没做完哦</p>
            <p>确定交卷吗？</p>
          </div>
        </div>
        <div class="img">
          <img src="@/assets/img/h5/newQuestionfinish@2x.png" />
        </div>
      </div>
      <span class="submit-footer" slot="footer">
        <div @click="submitAnswer(true)" class="black">确认交卷</div>
        <div @click="go_status = false" class="submit">取消继续答题</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AnswerSheet from '@/components/h5/questionBank/AnswerSheet.vue'
import CheckOption from '@/components/h5/questionBank/CheckOption.vue'
import RadioOption from '@/components/h5/questionBank/RadioOption.vue'
// import TextOption from '@/components/h5/questionBank/TextOption.vue'
import * as examination_API from '@/api/ExaminationAPI'
import * as dateUtil from '@/api/dateUtil'
export default {
  components: {
    AnswerSheet,
    CheckOption,
    RadioOption,
    // TextOption
  },
  data () {
    return {
      lastExaminationItemId: '',
      ExaminationItemList: [], //试题集合
      ExaminationInfo: {},
      showtList: [],
      actionType: '',  //1:开始答题 2重新答题 3继续答题
      passTime: '',
      startTime: '', //开始时间
      useTimeSend: 0, //继续答题 开始答题 的剩余时间
      title: '健康教育学',
      initData: '',
      baseUrl: sessionStorage.getItem('base_url') || '',
      loading: false,
      count: 0,
      page_index: 1,
      question_type: 1,
      token: '',
      copy_list: '',
      data_li: '',
      istrue: false,
      dataAll: '',
      submitData: [],
      numCount: 0,
      push_status: false,
      submit_status: false,
      // false为不是返回页面，true为返回上一页面
      isBlack: false,
      last_q_id: '',
      start_time: '',
      test_time: '',
      go_status: false,
      isFeed: false,
      c_no: sessionStorage.getItem('c_no'),
      timer: null,
      submitBoolean: true,
      //答题使用时间
      timess: ''
    };
  },
  computed: {
    statuss: function () {
      if (this.numCount == this.dataAll.length) {
        console.log(this.numCount)
        return true
      } else {
        return false
      }
    },
    closeText: function () {
      if (!this.isBlack && !this.statuss) {
        return '现在交卷'
      } else if (!this.isBlack && this.statuss) {
        return '再检查一下'
      } else {
        if (this.initData.parent_id == 2) {
          return '保存进度'
        } else {
          return '现在交卷'
        }
      }
    },
    submitText: function () {
      if (!this.isBlack && !this.statuss) {
        return '继续答题'
      } else if (!this.isBlack && this.statuss) {
        return '现在交卷'
      } else {
        return '继续答题'
      }
    },
    setTime () {
      let m = ''
      let s = ''
      m = parseInt(this.useTimeSend / 60)
      m = m >= 10 ? m : '0' + m
      s = this.useTimeSend % 60
      s = s >= 10 ? s : '0' + s
      return m + '分:' + s + '秒'
    }
  },
  watch: {
    numCount (val) {
      if (val > 0) {
        this.is_submit = false
      }
    }
  },
  created () {
    if (this.$route.params.data) {
      this.ExaminationInfo = this.$route.params.examination
      console.log(this.ExaminationInfo, 'route.ExaminationInfo')
      this.actionType = this.$route.params.actionType
    } else {
      this.ExaminationInfo = JSON.parse(sessionStorage.getItem('answerPage')).examination
      console.log(this.ExaminationInfo, 'JSON.ExaminationInfo')
      this.actionType = JSON.parse(sessionStorage.getItem('answerPage')).actionType
    }
    if (this.actionType == 3) {
      this.useTimeSend = sessionStorage.getItem('useTimeSend') || 0
      console.log(this.useTimeSend, 'sessionStorage')
      if (this.useTimeSend == 0) {
        this.useTimeSend = this.ExaminationInfo.testTime - this.ExaminationInfo.customerExaminationTestLogEntity.useTime
        console.log(this.useTimeSend, 'this.ExaminationInfo.testTime')
      }
    } else {
      this.useTimeSend = sessionStorage.getItem('useTimeSend') || this.ExaminationInfo.testTime
      console.log(this.useTimeSend, 'sessionStorage.ExaminationInfo.testTime')
    }

    this.examinationItemList()
    this.startime()
  },


  destroyed () {
    sessionStorage.removeItem('h5saveData')
    sessionStorage.removeItem('useTimeSend')
  },
  beforeDestroy () {   //页面关闭时清除定时器  

    clearInterval(this.timer)
  },
  filters: {
    setTimes: function (val) {
      if (val) {
        let m = Math.floor(val / 60)
        let s = Math.floor(val % 60)
        if (s < 10) {
          s = '0' + s
        }
        if (m < 10) {
          m = '0' + m
        }
        return m + ':' + s
      } else {
        return ''
      }
    },

  },

  methods: {
    startime: function () {
      this.timer = setInterval(() => {
        this.useTimeSend--
        console.log(this.useTimeSend, '--')
        sessionStorage.setItem('useTimeSend', this.useTimeSend)
        if (this.useTimeSend < 1) {
          this.$message.warning('倒计时已结束，一秒后自动交卷！')
          clearInterval(this.timer)
          setTimeout(() => {
            this.submitAnswer(true)
          }, 1000)
        }
      }, 1000);
    },

    //时间转换
    getDuration (val) {
      if (val) {
        return dateUtil.getDuration(val)
      }
    },


    //保存
    save () {
      //自动保存答题进度
      if (this.numCount > 0) {
        let arr = []
        for (let i = 0; i < this.submitData.length; i++) {
          arr[i] = this.submitData[i]
          if (Number(arr[i].questionType) === 2) {
            arr[i].select = this.submitData[i].select.length > 0 ? this.submitData[i].select.toString().replace(/[,]/g, '###') : ''
          } else {
            arr[i].select = this.submitData[i].select
          }
        }
        //    let useTime = sessionStorage.getItem('time')
        let data = {
          examSetting: JSON.stringify({ body: arr, lastExaminationItemId: this.lastExaminationItemId }),
          examinationId: this.ExaminationInfo.examinationId,
          courseId: this.ExaminationInfo.courseId,
          startTime: this.startTime,
          useTime: this.ExaminationInfo.testTime - this.useTimeSend,
          type: 3,
          isCommit: 2
        }
        examination_API.submitExaminationTestLog(data).then(res => {
          if (res && Number(res.code) === 0) {
            this.$message.success('保存当前考试进度成功')
            if (sessionStorage.getItem('isChannel')) {
              this.$router.push({
                path: '/h5/CourseDetail',
                query: {
                  token: localStorage.getItem('shangke_token'),
                  c_no: localStorage.getItem('c_no'),
                  cat_id: localStorage.getItem('cat_id'),
                  show_header: localStorage.getItem('show_header'),
                  show_data: localStorage.getItem('show_data')
                }
              })
            } else {
              this.$router.push('/h5/CourseDetail')
            }
            this.push_status = true
          } else {
            this.$message.warning('保存当前考试进度失败')
            if (sessionStorage.getItem('isChannel')) {
              this.$router.push({
                path: '/h5/CourseDetail',
                query: {
                  token: localStorage.getItem('shangke_token'),
                  c_no: localStorage.getItem('c_no'),
                  cat_id: localStorage.getItem('cat_id'),
                  show_header: localStorage.getItem('show_header'),
                  show_data: localStorage.getItem('show_data')
                }
              })
            } else {
              this.$router.push('/h5/CourseDetail')
            }
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        if (sessionStorage.getItem('isChannel')) {
          this.$router.push({
            path: '/h5/CourseDetail',
            query: {
              token: localStorage.getItem('shangke_token'),
              c_no: localStorage.getItem('c_no'),
              cat_id: localStorage.getItem('cat_id'),
              show_header: localStorage.getItem('show_header'),
              show_data: localStorage.getItem('show_data')
            }
          })
        } else {
          this.$router.push('/h5/CourseDetail')
        }
      }

    },
    submit_sub () {
      this.isBlack = false
      this.go_status = true
    },

    //试题列表
    examinationItemList () {
      const loading = this.$loading({
        text: '数据加载中……'
      });
      let data = {
        examinationId: this.ExaminationInfo.examinationId
      }
      examination_API.examinationItemList(data).then(res => {
        loading.close();
        if (res && Number(res.code) === 0) {
          this.loading = true
          this.startTime = parseInt(new Date().getTime() / 1000)//开始时间，秒为单位
          this.ExaminationItemList = res.data;
          this.count = res.data.length
          console.log(' this.count', this.count)
          // this.numTime = res.startTime + res.testTime
          let data = []
          for (let i = 0; i < this.ExaminationItemList.length; i++) {
            this.submitData[i] = {}
            this.submitData[i].examinationItemId = this.ExaminationItemList[i].examinationItemId
            this.submitData[i].questionType = this.ExaminationItemList[i].questionType
            this.submitData[i].questionAnswer = this.ExaminationItemList[i].questionAnswer
            this.submitData[i].select = ''
            // 保证继续答题获取到数据 以及选中状态
            // 上一个页面传递过来的类型，actionType 1: 开始答题 2：重新答题  3：继续答题  
            if (Number(this.actionType) === 3) {
              let examSetting = ''
              if (this.ExaminationInfo.customerExaminationTestLogEntity) {
                examSetting = JSON.parse(this.ExaminationInfo.customerExaminationTestLogEntity.examSetting).body//数据库答题记录
              }
              if (examSetting) {
                for (let s = 0; s < examSetting.length; s++) {
                  if (this.submitData[i].examinationItemId === examSetting[s].examinationItemId) {
                    this.submitData[i].select = examSetting[s].select
                    if (examSetting[s].select.indexOf('###') > -1) {
                      res.data[i].select = examSetting[s].select.split('###')
                      this.numCount++
                      console.log('numCount', this.numCount)
                      // 这个是保证测试时错误数据的清除
                    } else if (examSetting[s].select.indexOf('[') > -1) {
                      res.data[i].select = ''
                      console.log('bb')
                    } else if (examSetting[s].select) {
                      this.numCount++
                      console.log('numCount', this.numCount)
                      res.data[i].select = examSetting[s].select
                    } else {
                      res.data[i].select = ''
                    }
                  }
                }
              }
            }
            data[i] = this.ExaminationItemList[i]
            data[i].order = (i + 1)
          }
          this.dataAll = data
          console.log('ww', this.dataAll)
          // 保证刷新后用户的数据不丢失
          if (sessionStorage.getItem('h5saveData')) {
            this.numCount = 0
            this.dataAll = JSON.parse(sessionStorage.getItem('h5saveData'))
            for (let i = 0; i < this.dataAll.length; i++) {
              for (let s = 0; s < this.submitData.length; s++) {
                if (this.dataAll[i].examinationItemId === this.submitData[s].examinationItemId) {
                  if (this.dataAll[i].select instanceof Array) {
                    if (this.dataAll[i].select.length > 0) {
                      this.numCount++
                      this.submitData[s].select = this.dataAll[i].select.toString.replace(',', '###')
                    } else {
                      this.submitData[s].select = ''
                    }
                  } else {
                    if (this.dataAll[i].select) {
                      this.numCount++
                      this.submitData[s].select = this.dataAll[i].select
                    } else {
                      this.submitData[s].select = ''
                    }
                  }
                }
              }
            }
          }
          this.data_li = this.dataAll[this.page_index - 1]
          this.data_li.order = this.page_index
          this.question_type = this.data_li.questionType
          this.loading = false

        } else {
          this.$message.warning(res.message)
        }
      }).catch(err => {
        loading.close();
        console.log(err)
      })
    },

    handleSizeChange: function (val) {
      console.log('var', val)
      this.page_index = val
      this.data_li = this.dataAll[this.page_index - 1]
      this.question_type = this.data_li.questionType
      this.data_li.order = val


    },

    // 点击获取答案
    getchildval (obj) {
      console.log('点击获取答案', obj)
      if (obj.examinationItemId) {
        this.lastExaminationItemId = obj.examinationItemId
        for (let i = 0; i < this.submitData.length; i++) {
          if (this.submitData[i].examinationItemId === obj.examinationItemId) {
            if (obj.select instanceof Array) {
              //如果是多选题
              if (obj.select.length > 0) {
                this.submitData[i].select = obj.select.sort().toString().replace(/[,]/g, '###')
              } else {
                this.submitData[i].select = ''
              }
            } else {
              this.submitData[i].select = obj.select
            }
            this.dataAll[i].select = obj.select
          }
        }
        sessionStorage.setItem('h5saveData', JSON.stringify(this.dataAll))
        let num = 0
        for (let s = 0; s < this.submitData.length; s++) {
          if (this.submitData[s].select) {
            num++
          }
        }
        this.numCount = num
      }
    },





    //提交试卷前数据组装
    submitAnswer (status) {
      this.submitBoolean = false;
      if (status) {
        if (this.numCount >= 0) {
          let arr = []
          //  this.submitData = JSON.parse(sessionStorage.getItem('saveData'))
          for (let i = 0; i < this.submitData.length; i++) {
            arr[i] = this.submitData[i]
            if (Number(arr[i].questionType) === 2) {
              arr[i].select = this.submitData[i].select.toString().replace(/[,]/g, '###')
            } else {
              arr[i].select = this.submitData[i].select
            }
          }
          if (this.useTimeSend == 0) {
            this.timess = this.ExaminationInfo.testTime
          } else {
            console.log(this.useTimeSend, '倒计时')
            this.timess = this.ExaminationInfo.testTime - this.useTimeSend
          }
          let data = {
            examSetting: JSON.stringify({ body: arr, lastExaminationItemId: this.examinationId }),
            examinationId: this.ExaminationInfo.examinationId,
            courseId: this.ExaminationInfo.courseId,
            startTime: this.startTime,
            useTime: this.timess,
            type: 3,
            isCommit: 1
          }
          return this.submitExaminationTestLog(data)
        }

      }
    },

    // 提交试卷数据
    submitExaminationTestLog (data) {
      examination_API.submitExaminationTestLog(data).then(res => {
        if (res && Number(res.code) === 0) {
          let customerExaminationTestLogId = res.data
          this.ExaminationInfo.customerExaminationTestLogId = customerExaminationTestLogId;
          this.$message.success(res.msg)
          this.$router.push({
            name: 'ResultPage',
            params: this.ExaminationInfo
          })
          sessionStorage.setItem('resultPage', JSON.stringify(this.ExaminationInfo))
          this.push_status = true
        } else {
          this.$message.warning(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },


    pushHome () {
      this.isBlack = true
      this.submit_status = true
      // sessionStorage.removeItem('h5saveData')
      // this.$router.back()
    },
    // 关闭弹窗
    getstatus: function (val) {
      this.istrue = val
    },
    // 点击跳转题目
    getvalue (val) {
      console.log('点击跳转题目', val)
      this.page_index = val.order
      this.data_li = this.dataAll[this.page_index - 1]
      this.data_li.order = val.order
      this.question_type = this.data_li.questionType
    },

    pushResult: function () {
      this.go_status = false
      var state = {
        title: 'title',
        url: 'resultPage.html',
      }
      window.history.pushState(state, 'resultPage.html', '')
      location.href = 'resultPage.html'
    },

    reloadFn: function () {
      this.go_status = false
      location.reload()
    },
  }
}
</script>
<style scoped>
.header {
  width: 100%;
  display: flex;
  align-items: center;
  font-weight: bold;
  padding: 0.84375rem;
  border-bottom: 1px solid #eeeeee;
}
.header img {
  width: 1.2rem;
}
.header .title {
  width: 91%;
  text-align: center;
  font-size: 1.2rem;
}

.footer {
  position: fixed;
  height: 3rem;
  padding: 0 0 0 4%;
  width: 100%;
  align-items: center;
  left: 0;
  bottom: 0;
  box-shadow: 0px -2px 8.5px 0px rgba(237, 237, 237, 1);
  display: flex;
  justify-content: flex-end;
  background: #fff;
}
.Feed {
  position: relative;
}
.Feedback {
  position: absolute;
  left: 0.35rem;
  width: 6.25rem;
  display: flex;
  justify-content: center;
  padding-top: 0.35rem;
  color: #fff;
  height: 2.125rem;
  top: -2.7rem;
  background-image: url(~@/assets/img/h5/feedblack.png);
  background-size: cover;
}
.footer .page {
  position: relative;
}
.footer .timeOut {
  display: inline-flex;
  color: #ff2740;
  align-items: center;
}
.footer .time {
  display: inline-flex;
  color: #3aacffff;
  align-items: center;
}
.footer .timeOut img {
  height: 1.125rem;
  margin-right: 0.25rem;
}
.footer .page .submit {
  position: absolute;
  font-size: 1rem;
  letter-spacing: 0.5rem;
  color: #3aacffff;
  background-color: #fff;
  padding: 0.25rem 0.5625rem;
  cursor: pointer;
  right: 0;
  top: 0.2rem;
}
.footer button {
  color: #3aacffff;
}
#AnswerPage .footer button span {
  font-size: 1rem;
}
.footer button:disabled {
  color: #bbb;
}
.my_Body {
  width: 100%;
  height: 85vh;
  overflow-y: scroll;
  padding: 0.84375rem;
}
.question_box {
  width: 100%;
}
.question_header {
  margin-top: 1rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.question_body {
  margin-top: 1rem;
}
.question_header img {
  width: 0.65rem;
  margin-left: 0.2rem;
}
.header_count {
  display: inline-flex;
  align-items: center;
}

/*隐藏滚动条*/
::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}
.headers {
  font-size: 1rem;
  color: #3aacffff;
  margin-bottom: 2rem;
  width: 100%;
  text-align: center;
  font-weight: 800;
}
.dialog_body .img {
  width: 100%;
  display: flex;
  justify-content: center;
}
.img img {
  width: 40%;
  height: 40%;
}
.submit-footer {
  width: 100%;
}
.submit-footer .submit {
  width: 16rem;
  height: 2.4rem;
  border-radius: 1.25rem;
  text-align: center;
  line-height: 2.4rem;
  font-size: 1rem;
  color: #333333ff;
  background: rgba(249, 249, 249, 1);
  margin-top: 1rem;
}
.submit-footer .black {
  width: 16rem;
  height: 2.4rem;
  border-radius: 1.25rem;
  text-align: center;
  line-height: 2.4rem;
  font-size: 1rem;
  color: rgba(255, 255, 255, 1);
  background: linear-gradient(
    -3deg,
    rgba(74, 199, 255, 1),
    rgba(77, 167, 249, 1)
  );
}
.el-radio__input {
  line-height: 1;
  outline: 0;
  white-space: nowrap;
}
::v-deep .el-radio {
  white-space: normal;
}
.answer {
  background: #fff;
}
</style>